import { GetState, SetState } from 'zustand';
import { IBillItem } from '../../../types';
import { removeDuplicateBillsByBillId, updateItemByExternalId } from '../utils';

export interface IPaidBillsSlice {
  totalPaidBills: number;
  setTotalPaidBills: (payload: number) => void;
  paidBills: Array<IBillItem>,
  setPaidBills: (bills: Array<IBillItem> | [], shouldConcat: boolean) => void;
  paidBillsPageNumber: number,
  setPaidBillsPageNumber: (payload: number) => void,
  incrementPaidBillsPageNumber: () => void;
  setUpdatedPaidBillById: (externalId: string, docId:string) => void
  resetPaidBillsSlice: () => void;
}

const paidBillsInitialState = {
  paidBills: [],
  paidBillsPageNumber: 0,
  totalPaidBills: 0,
};

const createPaidBillsSlice = (set: SetState<IPaidBillsSlice>, get: GetState<IPaidBillsSlice>) => ({
  paidBills: [],
  setPaidBills: (bills: Array<IBillItem>, shouldConcat: boolean) => {
    if (!shouldConcat) set({ paidBills: removeDuplicateBillsByBillId(bills) });
    else set((prevState) => ({ paidBills: removeDuplicateBillsByBillId([...prevState.paidBills, ...bills]) }));
  },
  setUpdatedPaidBillById: (billId: string, docId: string) => {
    set({ paidBills: updateItemByExternalId(get().paidBills, billId, docId) });
  },
  incrementPaidBillsPageNumber: () => set((prevState) => ({ paidBillsPageNumber: prevState.paidBillsPageNumber + 1 })),
  paidBillsPageNumber: 0,
  setPaidBillsPageNumber: (payload: number) => {
    set({ paidBillsPageNumber: payload });
  },
  resetPaidBillsSlice: () => {
    set(paidBillsInitialState);
  },
  totalPaidBills: 0,
  setTotalPaidBills: (payload: number) => {
    set({ totalPaidBills: payload });
  },
});

export default createPaidBillsSlice;
